<template>
  <div v-if="selectedUser===null">
    <v-data-table :headers="standardHeaders"
                  :items="members"
                  :search="search"
                  :items-per-page="15"
                  class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field
            append-icon="mdi-magnify"
            v-model="search"
            single-line
            label="Suche"
            class="mx-4"
        />
      </template>

      <template v-slot:item.isActive="{ item }">
        <v-simple-checkbox
            v-model="item.isActive"
            disabled
        />
      </template>

      <template v-slot:item.isAdmin="{ item }">
        <v-simple-checkbox
            v-model="item.isAdmin"
            disabled
        />
      </template>

      <template v-if="superAdmin" v-slot:item.latestCourseSyncLabel="{ item }">
        <span v-if="item.hasCourseSyncRisk">{{ item.latestCourseSyncLabel }}</span>
      </template>

      <template v-if="superAdmin" v-slot:item.courseSyncStatus="{ item }">
        <v-chip v-if="item.hasCourseSyncRisk" color="warning" dark small>
          {{ item.courseSyncStatus }}
        </v-chip>
      </template>

      <template v-slot:item.edit="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                @click="openEdit(item)"
                class="ma-2"
                outlined
                x-small
                fab
                v-bind="attrs"
                v-on="on"
                color="indigo"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

          </template>
          <span>Bearbeiten</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
  <div v-else>
    <v-btn
        @click="selectedUser = null"
        class="ma-2"
        outlined
        x-small
        color="indigo"
    >
      Zurück
    </v-btn>
    <UserEdit @reload="$emit('reload')" :userId="selectedUser.id" @finish="onUserCreated" :super-admin="superAdmin"/>
  </div>
</template>

<script>

import User from "@/models/User";
import UserEdit from "@/components/UserEdit.vue";

export default {
  name: "MemberList",
  components: {UserEdit},
  data: () => ({
    selectedUser: null,
    search: "",
  }),
  props: {

    members: {
      type: Array,
      default: () => []
    },
    superAdmin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    standardHeaders() {
      const headers = [
        {
          text: "Username",
          value: "username",
          align: 'start',
        },
        {text: "E-Mail", value: "email"},
        {text: "Name", value: "name"},
        {text: "Nachname", value: "surname"},
        {text: "Departments", value: "companyDepartments"},
      ];

      if (this.superAdmin) {
        headers.push({text: "Letzter Kurs-Sync", value: "latestCourseSyncLabel"});
        headers.push({text: "Sync Status", value: "courseSyncStatus"});
      }

      headers.push({text: "Aktiv", value: "isActive"});
      headers.push({text: "Admin", value: "isAdmin"});
      headers.push({
        text: "Bearbeiten", value: "edit",
        sortable: false,
      });

      return headers;
    },
  },
  methods: {
    openEdit(item) {
      this.selectedUser = item;
    },
    onUserCreated(user) {
      this.members.unshift(user);
      this.selectedUser = null;
    },
    createUser() {
      this.selectedUser = new User({active: true, isAdmin: true})
    },
    clickBreadCrumb(text) {
      if (this.selectedUser && text === "Nutzer") {
        this.selectedUser = null;
        this.loadData();
      }
    },
  }
}
</script>

<style scoped>

</style>
